export enum OnboardingStep {
  EventTitle = -1,
  EventDate = 0,
  Groups = 1,
  Theme = 2,
  Finish = 3,
  Completed = 4
}
